import { default as insurCompaniesTypes } from "./types";

const {
  FETCH_INSUR_COMPANIES_REQUEST,
  FETCH_INSUR_COMPANIES_SUCCESS,
  FETCH_INSUR_COMPANIES_FAILURE,
} = insurCompaniesTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INSUR_COMPANIES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_INSUR_COMPANIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_INSUR_COMPANIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
